import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DownloadModel } from '../Modelo/download.model';
import { DownloadGeneralResponseModel } from '../Modelo/response/downloadResponseModel';
import { TrackBy } from '../Modelo/trackBy';
import { DownloadService } from '../servicios/download.service';

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss']
})
export class DownloadsComponent extends TrackBy implements OnInit{
  public imgUrl = './assets/images/download.png';
  private _downloads: Array<DownloadModel>;

  constructor(private _downloadsService: DownloadService) { 
    super();
  }

  ngOnInit(): void {
    this.loadFiles();
  }

  get downloads(): Array<DownloadModel> {
    return this._downloads;
  }

  onDownload(toDownload: DownloadModel): void {
    window.open(toDownload.url, '_blank');
  }

  loadFiles(): Promise<void> {
    return new Promise(async (resolve) => {
      try {
        const downloadResponse: DownloadGeneralResponseModel = await this._downloadsService.getDownloads();
        
        if ((downloadResponse?.Resultado?.length ?? 0) > 0) {
          if (this.downloads === null || this.downloads === undefined)
            this._downloads = new Array<DownloadModel>();
  
          downloadResponse.Resultado.forEach(currentDownload => {
            this._downloads.push(new DownloadModel(currentDownload.IdDescarga, currentDownload.Nombre, 
                                                   environment.UrlBase + environment.endpoint.files + '/Get/' +
                                                   currentDownload.IdArchivo));
          });
        }
      } catch (error) {
        if (!environment.production)
          console.log(error);
      } finally {
        resolve();
      }
    });
  }
}
